import {
    VehicleTaxMapCard,
    VehicleTaxMapForm,
    VehicleTaxMapList,
} from '../../containers/VehicleTaxMap';
import { accessTypeEnum } from '../../lib/enum';

export default [
    {
        component: VehicleTaxMapList,
        path: '/admin/vehicle-tax-map',
        access: [accessTypeEnum.admin, accessTypeEnum.adminBranch],
    },
    {
        component: VehicleTaxMapCard,
        path: '/admin/vehicle-tax-map/:id',
        access: [accessTypeEnum.admin, accessTypeEnum.adminBranch],
    },
    {
        component: VehicleTaxMapForm,
        path: '/admin/vehicle-tax-map/edit/:id',
        access: [accessTypeEnum.admin, accessTypeEnum.adminBranch],
    },
    {
        component: VehicleTaxMapForm,
        path: '/admin/vehicle-tax-map/new',
        access: [accessTypeEnum.admin, accessTypeEnum.adminBranch],
    },
];